export default __webpack_public_path__ + "static/media/close-white.e2dfcf66.svg";